import type { LabResultTemplateDocument } from '@type/lab_results.type'
import DocTemplatePreviewView from './DocTemplate/DocTemplatePreviewView'
import type { DocTemplatePreviewDocument } from './DocTemplate/templateDefinition'

export interface LabResultDocumentPreviewProps {
  document: LabResultTemplateDocument
}

/** Read-only snapshot of a captured template (`lab_result.attributes.document`). */
const LabResultDocumentPreview = ({ document: doc }: LabResultDocumentPreviewProps) => {
  const previewDoc: DocTemplatePreviewDocument = { ...doc, category: '' }

  return (
    <div className="lab-result-document-preview flex max-h-[min(70vh,720px)] flex-1 flex-col overflow-y-auto pr-1 text-left print:max-h-none print:overflow-visible">
      <DocTemplatePreviewView document={previewDoc} variant="snapshot" />
    </div>
  )
}

export default LabResultDocumentPreview
